import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ResumePage } from '@/features/interview-scoring/views/resume-page'

export type ResumeView = 'dossier' | 'sidebar' | 'evidence' | 'legacy'

const searchSchema = z.object({
  view: z.enum(['dossier', 'sidebar', 'evidence', 'legacy']).optional().default('dossier'),
})

function RouteComponent() {
  const { runId } = Route.useParams()
  const { view } = Route.useSearch()
  return <ResumePage runId={runId} view={view} />
}

export const Route = createFileRoute('/_authenticated/admin/interview-scoring/$runId/resume')({
  component: RouteComponent,
  validateSearch: searchSchema,
})
